<template>
  <div :class="classnames">
    <VueButton appearance="none" @click="handleClick">
      <template slot="text">Clear All Filters</template>
    </VueButton>
  </div>
</template>

<script>
  import VueButton from '@/components/VueButton'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'active-filters-list-clear-button'

  export default {
    name: 'ActiveFiltersListClearButton',
    components: {
      VueButton
    },
    mixins: [ bem ],
    data: function () {
      return {}
    },
    created: function () {
      this.setNamespace(namespace)
    },
    methods: {
      handleClick: function (event) {
        this.$emit('click', event)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ActiveFiltersListClearButton.vue